import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import useStyles from "./ShotsDefaultTable.styles";
import ShotsList from "../ShotsList/ShotsList.component";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component";

const ShotsDefaultTable = ({
  embedded,
  shotsList,
  isMultiSelectEnabled,
  selectedShots,
  setSelectedShots,
  shotPageToggler,
  updateRefreshCounter,
  setIsViewModalOpen,
  fetchFile,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  departmentsList,
  sliderState,
  handleTableScroll,
  tableRef,
  scrollValue,
  currentPage,
  setIsNewPageLoading,
  handlePageChange,
  statusList,
  sequenceId,
  projectId,
  handleSelectOrUnSelectShot,
}) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer className={classes.shotsTableContainer}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead className={classes.tableHeader}>
            <TableRow className={classes.tableRow}>
              {isMultiSelectEnabled && (
                <TableCell
                  align="left"
                  className={classes.shotPageTableCellTwo}
                  style={{
                    width: "40px",
                  }}
                >
                  <Checkbox
                    checked={
                      selectedShots?.length === shotsList.results?.length
                    }
                    onClick={() =>
                      selectedShots?.length === shotsList.results?.length
                        ? setSelectedShots([])
                        : setSelectedShots(shotsList.results)
                    }
                    inputProps={{ "aria-label": "controlled" }}
                    style={{
                      padding: "0",
                      minHeight: "0",
                    }}
                  />
                </TableCell>
              )}
              <TableCell align="left" className={classes.shotPageTableCellTwo}>
                Shots Name
              </TableCell>
              <TableCell align="center" className={classes.shotPageTableCell}>
                Last Modified
              </TableCell>
              <TableCell align="center" className={classes.shotPageTableCell}>
                Description
              </TableCell>
              <TableCell align="center" className={classes.shotPageTableCell}>
                Status
              </TableCell>
              <TableCell align="right" className={classes.shotPageTableCellTwo}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            className={classes.tableBody}
            onScroll={handleTableScroll}
            ref={tableRef}
            onLoad={() => {
              if (tableRef?.current && tableRef?.current?.scrollTop) {
                tableRef.current.scrollTop = scrollValue;
              }
            }}
            style={{
              height: embedded
                ? "100%"
                : shotsList.count > 50
                  ? `calc(100vh - 295px)`
                  : `calc(100vh - 250px)`,
            }}
          >
            {shotsList.results?.map((currShot, index) => (
              <ShotsList
                key={currShot.id}
                data={currShot}
                projectId={projectId}
                sequenceId={sequenceId}
                status={statusList}
                sliderState={sliderState}
                shotPageToggler={shotPageToggler}
                updateRefreshCounter={updateRefreshCounter}
                setIsViewModalOpen={setIsViewModalOpen}
                fetchFile={fetchFile}
                dragScreen={dragScreen}
                handleDragScreen={handleDragScreen}
                setDragFileEnterModal={setDragFileEnterModal}
                departmentsList={departmentsList}
                isMultiSelectEnabled={isMultiSelectEnabled}
                handleSelectOrUnSelectShot={(e) =>
                  handleSelectOrUnSelectShot(currShot, index, e)
                }
                selectedShots={selectedShots}
                customFields={shotsList?.custom_fields}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ShotsDefaultTable;
